module.exports = __webpack_public_path__ + "static/media/cross-white.d9b4a352.svg";